import React, {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import { DetailContext } from '@eas/common-web';

interface AttachmentContextType {
  visitedAttachments: string[];
  addVisitedAttachment: (id: string) => void;
  resetVisited: () => void;
}

const AttachmentContext = createContext<AttachmentContextType | null>(null);

interface AttachmentProviderProps {
  children: ReactNode;
}

export const AttachmentProvider: React.FC<AttachmentProviderProps> = ({
  children,
}) => {
  const [visitedAttachments, setVisitedAttachments] = useState<string[]>([]);

  const {
    source: { data },
  } = useContext(DetailContext);

  const addVisitedAttachment = (id: string) => {
    if (visitedAttachments.includes(id)) return;

    setVisitedAttachments((prev) => [...prev, id]);
  };

  const resetVisited = () => {
    setVisitedAttachments([]);
  };

  useEffect(() => {
    resetVisited();
  }, [data?.id]);

  return (
    <AttachmentContext.Provider
      value={{ visitedAttachments, addVisitedAttachment, resetVisited }}
    >
      {children}
    </AttachmentContext.Provider>
  );
};

export const useAttachmentContext = (): AttachmentContextType => {
  const context = useContext(AttachmentContext);
  if (!context) {
    throw new Error(
      'useAttachmentContext must be used within an AttachmentProvider'
    );
  }
  return context;
};
